<div class="modal-body">
    <button class="close" (click)="closeAndDestroy()">
        <i class="fa-light fa-xmark"></i>
    </button>
    <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3 order-chooser">
        <app-order-chooser class="order-chooser flex flex-center flex-h-center" [customer]="orderOnBehalfService.customerAsObservable() | async" (orderIdChange)="onSelect($event)"></app-order-chooser>
    </div>
</div>